import { render } from "./SearchFunction.vue?vue&type=template&id=1f188cb6"
import script from "./SearchFunction.vue?vue&type=script&lang=js"
export * from "./SearchFunction.vue?vue&type=script&lang=js"

import "./SearchFunction.vue?vue&type=style&index=0&id=1f188cb6&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__